import React, {useEffect, useState} from 'react';
import {NoActionStage} from '../components/application/client/NoActionStage';
import {RejectedStage} from '../components/application/client/RejectedStage';
import {Layout} from '../components/common/Layout';
import {CompletedStage} from '../components/application/client/CompletedStage';
import {useQuery} from "@apollo/client";
import {GET_MY_APPLICATION_DETAILS, Stage} from "../api/application/getMyApplicationDetails";
import {getSubtitle} from "../components/application/admin/util";
import {useNavigate} from "react-router-dom";
import {UploadStage} from "../components/application/client/UploadStage";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {statusColorMap, statusMap} from "./Applications";

export const MyApplication = () => {
    const [stages, setStages] = useState<Stage[]>([])

    const navigate = useNavigate();

    const {loading, data, refetch} = useQuery(GET_MY_APPLICATION_DETAILS);

    useEffect(() => {
        if (data !== undefined) {
            setStages([...data.showMyApplicationDetails.applicationStages].sort((a, b) => a.order - b.order))
        }
    }, [data])

    useEffect(() => {
        if (data && data.showMyApplicationDetails.package === null) {
            navigate('/welcome')
        }
    }, [data])

    return (
        <Layout
            chip={data && data.showMyApplicationDetails.package ? data.showMyApplicationDetails.package.code : ''}
            isLoading={loading}
            showHeader
            title={data && data.showMyApplicationDetails.profile ? data.showMyApplicationDetails.profile.company : ''}
        >
            <CompletedStage
                date={`Completed on ${new Date(data ? data.showMyApplicationDetails.profile.agreementSignedAt : '').toDateString()}`}
                id={'Agreement'}
                title={'Agreement Signed'}
            />

            {
                stages.map(stage => {
                    if (stage.stageStatus === 'PENDING') return null

                    if (stage.stageStatus === 'APPROVED') {
                        return (
                            <CompletedStage
                                date={`Completed on ${new Date(stage.updatedAt).toDateString()}`}
                                id={stage.id}
                                key={stage.id}
                                title={stage.title}
                            />
                        )
                    } else if (stage.stageStatus === 'REJECTED') {
                        return (
                            <RejectedStage
                                date={`Rejected on ${new Date(stage.updatedAt).toDateString()}`}
                                description={stage.description}
                                id={stage.id}
                                key={stage.id}
                                rejectionMessage={stage.rejectionMessage}
                                title={stage.title}
                            />
                        )
                    } else if (stage.stageType === 'NO_ACTION' || stage.stageType === 'APPROVAL') {
                        return (
                            <NoActionStage
                                description={stage.description}
                                id={stage.id}
                                key={stage.id}
                                period={getSubtitle(stage)}
                                title={stage.title}
                            />
                        )
                    } else if (stage.stageType === 'UPLOAD') {
                        return (
                            <UploadStage
                                description={stage.description}
                                disabled={data ? data.showMyApplicationDetails.status !== 'IN_PROGRESS' : true}
                                files={stage.files}
                                id={stage.id}
                                key={stage.id}
                                refetch={refetch}
                                title={stage.title}
                            />
                        )
                    }
                })
            }

            {data && data.showMyApplicationDetails.status !== 'IN_PROGRESS' ? (
                <Stack marginTop="1rem">
                    <Stack direction="row">
                        <Typography width='10rem'>
                            Application status:
                        </Typography>
                        <Typography component='span' color={statusColorMap[data.showMyApplicationDetails.status]}>
                            {statusMap[data.showMyApplicationDetails.status]}
                        </Typography>
                    </Stack>

                    <Stack direction="row">
                        <Typography width='10rem'>
                            Last updated at:
                        </Typography>
                        <Typography component='span'>
                            {new Date(data.showMyApplicationDetails.updatedAt).toUTCString()}
                        </Typography>
                    </Stack>
                </Stack>
            ) : undefined}
        </Layout>
    )
}
